import { Badge } from '@radix-ui/themes';
import { BallHelper } from 'lib_ts/classes/ball.helper';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IBallState } from 'lib_ts/interfaces/pitches';

export const CommonSpinBadge = (props: { bs: IBallState }) => {
  const spin = (props.bs.wnet ?? BallHelper.getNetSpin(props.bs)).toFixed(0);

  return (
    <Badge color={RADIX.COLOR.NEUTRAL}>
      {spin}
      <span className="BadgeUnits">RPM</span>
    </Badge>
  );
};
